import { Box, Button, Card, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import brandLogo from '../../assets/Images/brandlogo.png'
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ApiUsersLogin, ApiVerifyEmail } from '../../apiService/Core/Apicall';
import { loginSuccess } from '../../global/config/Reducer/authSlice';
import { useDispatch } from 'react-redux';
import PopupDialog from '../Popups/ConfirmDialog';

const OTP_LENGTH = 4;
const TIMER_SECONDS = 120;

const Otp: React.FC = () => {
    const [otp, setOtp] = useState<string[]>(Array(OTP_LENGTH).fill(""));
    const [timeLeft, setTimeLeft] = useState(TIMER_SECONDS);
    const [isExpired, setIsExpired] = useState(false);
    const [error, setError] = useState<string>("");
    const navigate = useNavigate();
    const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
    const location = useLocation();
    const email = location.state?.email || '';
    const password = location.state?.password || '';
    const dispatch = useDispatch();
    const [errorPopup, setErrorPopup] = useState<{ open: boolean; message: string }>({
        open: false,
        message: '',
    })

    useEffect(() => {
        if (timeLeft === 0) {
            setIsExpired(true);
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    const formatTime = () => {
        const min = Math.floor(timeLeft / 60);
        const sec = timeLeft % 60;
        return `${min}:${sec.toString().padStart(2, "0")}`;
    };

    const handleChange = (value: string, index: number) => {
        if (!/^\d?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (error) setError("");

        if (value && index < OTP_LENGTH - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleVerify = async () => {
        if (otp.some(val => val === "")) {
            setError("Please enter the complete OTP");
            return;
        }

        const finalOtp = otp.join("");
        console.log("OTP:", finalOtp);
        try {
            const data = {
                email,
                otp: finalOtp
            }

            const res = await ApiVerifyEmail(data);
            if (res?.status) {
                const userData = res.data;
                dispatch(loginSuccess({ token: userData.userToken, user: userData }));
                localStorage.setItem('token', userData.userToken);
                navigate('/admin/dashboard');
                toast.success(res.message);
            }
        } catch (error: any) {
            console.error("Login error:", error);
            setErrorPopup({
                open: true,
                message: error?.message || error?.response?.data?.message || error || 'Something went wrong. Please try again.',
            })
        }
    };


    const handleKeyDown = (
        e: any,
        index: number
    ) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const handleResend = async () => {
        setOtp(Array(OTP_LENGTH).fill(""));
        setTimeLeft(TIMER_SECONDS);
        setIsExpired(false);
        inputRefs.current[0]?.focus();
        try {
            const data = {
                email,
                password
            }
            const response = await ApiUsersLogin(data);
            if (response?.status) {
                toast.info(response.message)
            }
        } catch (error: any) {
            console.error("Login error:", error);
            setErrorPopup({
                open: true,
                message: error?.message || error?.response?.data?.message || error || 'Something went wrong. Please try again.',
            })
        }
    };

    return (
        <div className='container'>
            <Card className='login-card'>
                <Box className="col-5 p-5 login-brand-logo">
                    <img src={brandLogo} alt='#' />
                </Box>
                <Box className="col-12 col-xl-7 bg-dark-color p-xl-4 p-3">
                    <Box className="d-flex flex-column" gap={1}>
                        <Typography className='fs-18' color='#898989' fontWeight={600}>Verify the Authentication Code</Typography>
                        <Typography className='fs-12' color='#898989'>Sent to {email}</Typography>
                    </Box>
                    <Box className="d-flex mt-4 align-items-center justify-content-center">
                        {otp.map((value, index) => (
                            <React.Fragment key={`otp-${index}`}>
                                <TextField
                                    error={!!error && !value}
                                    inputRef={el => (inputRefs.current[index] = el)}
                                    value={value}
                                    onChange={e => handleChange(e.target.value, index)}
                                    onKeyDown={e => handleKeyDown(e, index)}
                                    inputProps={{
                                        maxLength: 1,
                                        style: {
                                            textAlign: "center",
                                            fontSize: "20px",
                                            color: "#fff"
                                        }
                                    }}
                                    sx={{
                                        width: 56,
                                        mx: 1,
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "10px",
                                            backgroundColor: "transparent",
                                        },
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: error && !value ? "red" : "#fff",
                                        },
                                        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#fff",
                                        },
                                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#cc583f",
                                        },
                                    }}
                                />
                                {index < OTP_LENGTH - 1 && (
                                    <Typography
                                        sx={{
                                            color: "#898989",
                                            fontSize: "20px",
                                            fontWeight: 500
                                        }}
                                    >
                                        -
                                    </Typography>
                                )}
                            </React.Fragment>
                        ))}
                    </Box>
                    <Box className="mt-3 d-flex align-items-center justify-content-center">
                        {!isExpired ? (
                            <Typography color="#898989">{formatTime()}</Typography>
                        ) : (
                            <Button
                                variant="text"
                                sx={{ color: "#898989", p: 0 }}
                                onClick={handleResend}
                            >
                                RESEND
                            </Button>
                        )}
                    </Box>

                    <Button className='bg-orange text-white'
                        fullWidth
                        onClick={handleVerify}
                        sx={{
                            mt: 4,
                            padding: 2,
                            borderRadius: "12px",
                            fontWeight: 600,
                        }}
                    >
                        Verify
                    </Button>
                </Box>
            </Card>
            <PopupDialog
                open={errorPopup.open}
                onClose={() => setErrorPopup({ open: false, message: '' })}
                onConfirm={() => setErrorPopup({ open: false, message: '' })}
                variant="error"
                title="Something Went Wrong"
                message={errorPopup.message}
                confirmText="Try Again"
                cancelText="Dismiss"
            />
        </div>
    )
}

export default Otp
